import { Box, Card, Typography } from '@mui/material';
import CommonForm from 'components/commonForm/CommonForm';
import ConfirmModal from 'components/confirmModal/ConfirmModal';
import PolicyHeader from 'pages/faq/PolicyHeader';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { accountDeletionAction } from 'redux/actions/accountDeletion';

const AccountDeletion = () => {

    const searchParams = new URLSearchParams(window.location.search);
    const isMobileParams = searchParams.get('isMobile');
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);

    const formSubmit = (data, reset) => {
        dispatch(accountDeletionAction(data, setOpen, reset));
    }

    const formData = [
        {
            placeholder: 'Enter your name',
            required: true,
            type: 'text',
            name: 'name',
            label: 'Name',
            star: '*',
        },
        {
            placeholder: 'Enter your email',
            required: true,
            type: 'text',
            name: 'email',
            label: 'Email',
            star: '*',
        },
        {
            placeholder: 'Enter your phone number',
            required: true,
            type: 'number',
            name: "phoneNumber",      
            maxlength: 10,      
            label: 'Phone No',
            star: '*',
        },
        {
            placeholder: 'Enter your official email',
            required: false,
            type: 'textArea',
            row: 1,
            multiline: true,
            name: 'message',
            label: 'Message (Optional)',
            countrycode: false,
        },
    ]

  return (
   <Box className="container accountDeletionFormContainer">
      {!isMobileParams && <PolicyHeader/>}
      <Box className="accountDeletionForm">
        <Card className="customFormCard">
            <Typography variant='head4' component={"p"} className='fw600 textCenter'>Request for Account Deletion</Typography>
            <CommonForm
                formData={formData}
                button={'Submit'}
                onSubmittBtn={formSubmit}
                resetFormType={"accountDeletion"}
            />
        </Card>
      </Box>
      {open && <ConfirmModal open={open} toggle={() => setOpen(false)} pageName={"accountDeletionModal"} />}
   </Box> 
  )
}

export default AccountDeletion
